export const ETolgeeRequests = {
  TITLE: 'requests.title',
  LIST_TITLE: 'requests.list.title',
  LIST_TITLE_2: 'requests.list.title2',
  LIST_SUBTITLE: 'requests.list.subtitle',
  LIST_CAMPAIGN_NAME: 'requests.list.campaignName',
  LIST_REQUEST_ID: 'requests.list.requestId',
  LIST_REQUEST_DATE: 'requests.list.requestDate',
  LIST_REQUEST_SOURCE: 'requests.list.requestSource',
  LIST_EMPLOYEE: 'requests.list.employee',
  LIST_COMPANY_NAME: 'requests.list.companyName',
  LIST_OPERATION_TYPE: 'requests.list.operationType',
  LIST_EFFECTIVE_DATE: 'requests.list.effectiveDate',
  LIST_STATUS: 'requests.list.status',
  MODAL_DETAILS_TITLE: 'requests.modal.details.title',
  MODAL_DETAILS_REQUEST_NUMBER: 'requests.modal.details.requestNumber',
  MODAL_DETAILS_OPERATION: 'requests.modal.details.operation',
  MODAL_DETAILS_EMPLOYEE: 'requests.modal.details.employee',
  MODAL_DETAILS_ORIGIN: 'requests.modal.details.origin',
  MODAL_DETAILS_COMPANY: 'requests.modal.details.company',
  MODAL_DETAILS_REQUEST_DATE: 'requests.modal.details.requestDate',
  MODAL_DETAILS_EFFECTIVE_DATE: 'requests.modal.details.effectiveDate',
  MODAL_DETAILS_ADHESION_DATE: 'requests.modal.details.adhesionDate',
  MODAL_DETAILS_IAPP_TIME: 'requests.modal.details.iappTime',
  MODAL_DETAILS_BASIC_CONTRIBUTION: 'requests.modal.details.basicContribution',
  MODAL_DETAILS_REPROCESS_ONE_REQUEST_SUCCESS:
    'requests.modal.details.reprocessOneRequestSuccess',
  MODAL_DETAILS_REPROCESS_ONE_REQUEST_ERROR:
    'requests.modal.details.reprocessOneRequestError',
  MODAL_DETAILS_ADDITIONAL_CONTRIBUTION:
    'requests.modal.details.additionalContribution',
  MODAL_DETAILS_ADDITIONAL_CONTRIBUTION_PERCENTAGE:
    'requests.modal.details.additionalContributionPercentage',
  MODAL_DETAILS_CONTRIBUTE_WITH_13TH_SALARY:
    'requests.modal.details.contributeWith13thSalary',
  MODAL_DETAILS_CONTRIBUTE_WITH_BONUS:
    'requests.modal.details.contributeWithBonus',
  MODAL_DETAILS_CONTRIBUTE_WITH_GCA: 'requests.modal.details.contributeWithGCA',
  MODAL_DETAILS_INVESTMENT_PROFILE: 'requests.modal.details.investmentProfile',
  MODAL_DETAILS_TAX_REGIME: 'requests.modal.details.taxRegime',
  MODAL_DETAILS_DESIGNATED_PERSONS_COUNT:
    'requests.modal.details.designatedPersonsCount',
  MODAL_DETAILS_POLITICALLY_EXPOSED:
    'requests.modal.details.politicallyExposed',
  MODAL_DETAILS_DOWNLOAD_DECLARATIONS:
    'requests.modal.details.downloadDeclarations',
  ACTION_REJECT: 'action.reject',
  ACTION_VIEW_DETAILS: 'action.viewDetails',
  ACTION_HOLD_REQUEST: 'action.holdRequest',
  ACTION_CANCEL_REQUEST: 'action.cancelRequest',
  ACTION_DOWNLOAD_DECLARATIONS: 'action.downloadDeclarations',
  LIST_DELETE_REQUEST: 'requests.list.deleteRequest',
  LIST_DELETE_REQUEST_CONFIRMATION_1:
    'requests.list.deleteRequestConfirmation1',
  LIST_DELETE_REQUEST_CONFIRMATION_2:
    'requests.list.deleteRequestConfirmation2',
  LIST_DELETE_REQUEST_CONFIRMATION_DESCRIPTION_1:
    'requests.list.deleteRequestConfirmationDescription1',
  LIST_DELETE_REQUEST_CONFIRMATION_DESCRIPTION_2:
    'requests.list.deleteRequestConfirmationDescription2',
  EMPLOYEE_REJECT_ACTION: 'employee.action.reject',
  REQUEST_REJECTING: 'components.requestList.rejecting',
  REQUEST_REJECTED: 'components.requestList.rejected',
  REQUEST_REJECT_CONFIRMATION_TITLE: 'requestList.rejectModal.title',
  REQUEST_REJECT_CONFIRMATION_DESCRIPTION: 'requestList.rejectRequest.content',
  LIST_EMPTY_TITLE: 'employee.history.emptyTitle',
  LIST_EMPTY_SUBTITLE: 'employee.history.emptySubtitle',
  REPROCESS_CAMPAIGNS: 'components.requestList.reprocessCampaigns',
  REPROCESS_CAMPAIGNS_MODAL_TITLE:
    'components.requestList.reprocessCampaignsModalTitle',
  REPROCESS_CAMPAIGNS_MODAL_DESCRIPTION:
    'components.requestList.reprocessCampaignsModalDescription',
  REPROCESS_CAMPAIGNS_SUCCESS:
    'components.requestList.reprocessCampaignsSuccess',
  REPROCESS_CAMPAIGNS_ERROR: 'components.requestList.reprocessCampaignsError',
  ACTION_REPROCESS: 'components.requestList.actionReprocess'
} as const;

export type ETolgeeRequests =
  (typeof ETolgeeRequests)[keyof typeof ETolgeeRequests];
